(() => {
  'use strict';

  if (window.__rdFrequentlyBoughtReady) return;
  window.__rdFrequentlyBoughtReady = true;

  const ROOT = '[data-rd-fbt]';

  const formatMoney = (root, cents) => {
    const currency = root.dataset.currencyCode || 'INR';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-IN',
        {
          style: 'currency',
          currency,
          maximumFractionDigits: 0
        }
      ).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${currency} ${Math.round((Number(cents) || 0) / 100)}`;
    }
  };

  const getSelectedExtras = (root) =>
    Array.from(
      root.querySelectorAll(
        '[data-rd-fbt-checkbox]:checked:not(:disabled)'
      )
    )
      .map((checkbox) => ({
        id: Number(checkbox.dataset.variantId),
        quantity: 1,
        price: Number(checkbox.dataset.price) || 0,
        compare:
          Number(checkbox.dataset.compare) ||
          Number(checkbox.dataset.price) ||
          0
      }))
      .filter((item) => item.id);

  const updateTotals = (root) => {
    const items = getSelectedExtras(root);

    const priceTotal =
      items.reduce(
        (sum, item) => sum + item.price,
        0
      );

    const compareTotal =
      items.reduce(
        (sum, item) => sum + item.compare,
        0
      );

    const saving =
      Math.max(
        0,
        compareTotal - priceTotal
      );

    const count =
      root.querySelector(
        '[data-rd-fbt-count]'
      );

    const price =
      root.querySelector(
        '[data-rd-fbt-price-total]'
      );

    const compare =
      root.querySelector(
        '[data-rd-fbt-compare-total]'
      );

    const savingEl =
      root.querySelector(
        '[data-rd-fbt-saving]'
      );

    const button =
      root.querySelector(
        '[data-rd-fbt-add]'
      );

    if (count) {
      count.textContent =
        String(items.length);
    }

    if (price) {
      price.textContent =
        formatMoney(
          root,
          priceTotal
        );
    }

    if (compare) {
      const hideCompare =
        !items.length ||
        compareTotal <= priceTotal;

      compare.hidden =
        hideCompare;

      compare.classList.toggle(
        'is-hidden',
        hideCompare
      );

      compare.textContent =
        hideCompare
          ? ''
          : formatMoney(
              root,
              compareTotal
            );
    }

    if (savingEl) {
      const showSaving =
        items.length > 0 &&
        saving > 0;

      savingEl.textContent =
        showSaving
          ? `Save ${formatMoney(root, saving)}`
          : '';

      savingEl.hidden =
        !showSaving;

      savingEl.style.display =
        showSaving
          ? 'inline-flex'
          : 'none';
    }

    if (
      button &&
      !button.classList.contains(
        'is-loading'
      )
    ) {
      button.disabled =
        items.length === 0;
    }
  };

  const updatePairedVariant = (root, select) => {
    const item = select.closest('[data-rd-fbt-item]');
    const checkbox = item?.querySelector('[data-rd-fbt-checkbox]');
    const option = select.selectedOptions?.[0];

    if (!item || !checkbox || !option) return;

    const variantId = Number(option.value || 0);
    const price = Number(option.dataset.price || 0);
    const compare = Number(option.dataset.compare || option.dataset.price || 0);
    const available = option.dataset.available !== 'false';
    const discount = Number(option.dataset.discount || 0);

    checkbox.dataset.variantId = String(variantId || '');
    checkbox.dataset.price = String(price || 0);
    checkbox.dataset.compare = String(compare || price || 0);
    checkbox.disabled = !available || !variantId;

    if (checkbox.disabled) checkbox.checked = false;

    const priceEl = item.querySelector('[data-rd-fbt-price]');
    const compareEl = item.querySelector('[data-rd-fbt-compare]');
    const discountEl = item.querySelector('[data-rd-fbt-discount]');
    const imageEl = item.querySelector('.rd-fbt__image');

    if (priceEl) {
      priceEl.textContent =
        option.dataset.priceMoney ||
        formatMoney(root, price);
    }

    if (compareEl) {
      const showCompare = compare > price;

      compareEl.hidden = !showCompare;
      compareEl.classList.toggle('is-hidden', !showCompare);
      compareEl.textContent = showCompare
        ? (option.dataset.compareMoney || formatMoney(root, compare))
        : '';
    }

    if (discountEl) {
      const showDiscount = discount > 0;

      discountEl.hidden = !showDiscount;
      discountEl.classList.toggle('is-hidden', !showDiscount);
      discountEl.textContent = showDiscount ? `${discount}% OFF` : '';
    }

    if (imageEl && option.dataset.image) {
      imageEl.src = option.dataset.image;
      imageEl.srcset = '';
    }

    item.classList.toggle('is-unavailable', !available);

    updateTotals(root);
  };

  const getMainForm = (root) => {
    const id =
      root.dataset.mainFormId;

    return id
      ? document.getElementById(id)
      : null;
  };

  const getMainVariantId = (root) => {
    const form =
      getMainForm(root);

    return Number(
      form?.querySelector(
        '[name="id"]'
      )?.value || 0
    );
  };

  const getMainQuantity = (root) => {
    const form =
      getMainForm(root);

    if (!form?.id) return 1;

    const quantity =
      document.querySelector(
        `[name="quantity"][form="${CSS.escape(form.id)}"]`
      ) ||
      form.querySelector(
        '[name="quantity"]'
      );

    const value =
      Number(
        quantity?.value || 1
      );

    return Math.max(
      1,
      Number.isFinite(value)
        ? value
        : 1
    );
  };

  const showError = (
    root,
    message = ''
  ) => {
    const error =
      root.querySelector(
        '[data-rd-fbt-error]'
      );

    if (!error) return;

    const hidden =
      !message;

    error.hidden =
      hidden;

    error.classList.toggle(
      'is-hidden',
      hidden
    );

    error.textContent =
      message;
  };

  const addItems = async (root) => {
    const extras =
      getSelectedExtras(root);

    const mainVariantId =
      getMainVariantId(root);

    const button =
      root.querySelector(
        '[data-rd-fbt-add]'
      );

    const label =
      root.querySelector(
        '[data-rd-fbt-button-label]'
      );

    const spinner =
      button?.querySelector(
        '.loading__spinner'
      );

    if (
      !button ||
      !extras.length
    ) {
      return;
    }

    if (!mainVariantId) {
      showError(
        root,
        'Select the main product variant first.'
      );

      return;
    }

    const cart =
      document.querySelector(
        'cart-notification'
      ) ||
      document.querySelector(
        'cart-drawer'
      );

    const items = [
      {
        id: mainVariantId,
        quantity:
          getMainQuantity(root)
      },
      ...extras.map(
        ({ id, quantity }) => ({
          id,
          quantity
        })
      )
    ];

    const payload = {
      items
    };

    if (
      cart?.getSectionsToRender
    ) {
      payload.sections =
        cart
          .getSectionsToRender()
          .map(
            (section) =>
              section.id
          );

      payload.sections_url =
        window.location.pathname;

      cart.setActiveElement?.(
        button
      );
    }

    button.classList.add(
      'is-loading'
    );

    button.disabled =
      true;

    spinner?.classList.remove(
      'hidden'
    );

    showError(root);

    try {
      const response =
        await fetch(
          routes.cart_add_url,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body:
              JSON.stringify(
                payload
              )
          }
        );

      const data =
        await response.json();

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add items.'
        );
      }

      /*
        Dawn's cart drawer expects an id plus the returned
        section HTML. Multi-item cart/add can return items
        without a top-level id, so provide the main variant.
      */

      if (!data.id) {
        data.id =
          data.items?.[0]?.id ||
          mainVariantId;
      }

      if (
        typeof publish === 'function' &&
        window.PUB_SUB_EVENTS?.cartUpdate
      ) {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source:
              'rd-frequently-bought',
            productVariantId:
              mainVariantId,
            cartData:
              data
          }
        );
      }

      if (
        cart?.renderContents &&
        data.sections
      ) {
        cart.renderContents(
          data
        );
      } else if (!cart) {
        window.location =
          routes.cart_url;

        return;
      }

      root
        .querySelectorAll(
          '[data-rd-fbt-checkbox]'
        )
        .forEach(
          (checkbox) => {
            checkbox.checked =
              false;
          }
        );

      updateTotals(root);

      if (label) {
        label.textContent =
          'Added';

        window.setTimeout(
          () => {
            label.textContent =
              label.dataset.defaultLabel ||
              'Add items to bag';
          },
          900
        );
      }
    } catch (error) {
      showError(
        root,
        error.message ||
        'Unable to add items.'
      );
    } finally {
      button.classList.remove(
        'is-loading'
      );

      spinner?.classList.add(
        'hidden'
      );

      updateTotals(root);
    }
  };

  const init = (root) => {
    if (
      !root ||
      root.dataset.rdFbtReady ===
        'true'
    ) {
      return;
    }

    root.dataset.rdFbtReady =
      'true';

    root
      .querySelectorAll('[data-rd-fbt-variant-select]')
      .forEach((select) => {
        updatePairedVariant(root, select);

        select.addEventListener('change', () => {
          updatePairedVariant(root, select);
        });

        select.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

    updateTotals(root);
  };

  const initAll = (
    scope = document
  ) => {
    if (
      scope.matches?.(ROOT)
    ) {
      init(scope);
    }

    scope
      .querySelectorAll?.(ROOT)
      .forEach(init);
  };

  document.addEventListener(
    'change',
    (event) => {
      const checkbox =
        event.target.closest?.(
          '[data-rd-fbt-checkbox]'
        );

      const root =
        checkbox?.closest(ROOT);

      if (root) {
        updateTotals(root);
      }
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      const button =
        event.target.closest?.(
          '[data-rd-fbt-add]'
        );

      const buttonRoot =
        button?.closest(ROOT);

      if (buttonRoot) {
        addItems(buttonRoot);
        return;
      }

      const item =
        event.target.closest?.(
          '[data-rd-fbt-item]'
        );

      if (!item) return;

      if (
        event.target.closest(
          'select, option, button, a, input, label'
        )
      ) {
        return;
      }

      const checkbox =
        item.querySelector(
          '[data-rd-fbt-checkbox]'
        );

      if (!checkbox || checkbox.disabled) return;

      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(
        event.target
      );
    }
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(document),
      {
        once: true
      }
    );
  } else {
    initAll(document);
  }
})();